import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { SearchInput } from '../../components/ui/Input';
import { Building2, Users, FolderOpen, ArrowLeft, MoreHorizontal, ExternalLink, Link as LinkIcon, Copy, Check, Edit2, X, Save } from 'lucide-react';
const builderData: Record<string, any> = {
  '1': {
    name: 'Excel Homes',
    slug: 'excel',
    status: 'Active',
    users: 8,
    buyers: 342,
    joinedDate: '2023-06-15',
    projects: [{
      id: 1,
      name: 'The Riverside Collection',
      status: 'Active',
      buyers: 124,
      lastActivity: '2 hours ago'
    }, {
      id: 2,
      name: 'Oakwood Estates',
      status: 'Active',
      buyers: 89,
      lastActivity: '1 day ago'
    }, {
      id: 3,
      name: 'Maple Ridge',
      status: 'Active',
      buyers: 67,
      lastActivity: '3 hours ago'
    }, {
      id: 4,
      name: 'Cedar Point',
      status: 'Draft',
      buyers: 0,
      lastActivity: '5 days ago'
    }]
  },
  '2': {
    name: 'Schell Brothers',
    slug: 'schell',
    status: 'Active',
    users: 12,
    buyers: 567,
    joinedDate: '2023-03-22',
    projects: [{
      id: 5,
      name: 'Coastal Living',
      status: 'Active',
      buyers: 234,
      lastActivity: '1 hour ago'
    }, {
      id: 6,
      name: 'Beach House Collection',
      status: 'Active',
      buyers: 189,
      lastActivity: '4 hours ago'
    }, {
      id: 7,
      name: 'Seaside Villas',
      status: 'Active',
      buyers: 144,
      lastActivity: '2 days ago'
    }]
  },
  '3': {
    name: 'Mattamy Homes',
    slug: 'mattamy',
    status: 'Active',
    users: 20,
    buyers: 892,
    joinedDate: '2022-11-10',
    projects: [{
      id: 8,
      name: 'Summit Ridge',
      status: 'Active',
      buyers: 312,
      lastActivity: '30 mins ago'
    }, {
      id: 9,
      name: 'Valley View',
      status: 'Active',
      buyers: 278,
      lastActivity: '2 hours ago'
    }, {
      id: 10,
      name: 'Highland Park',
      status: 'Active',
      buyers: 302,
      lastActivity: '5 hours ago'
    }]
  },
  '4': {
    name: 'Landmark Homes',
    slug: 'landmark',
    status: 'Trial',
    users: 3,
    buyers: 45,
    joinedDate: '2024-01-10',
    projects: [{
      id: 11,
      name: 'Pioneer Square',
      status: 'Active',
      buyers: 45,
      lastActivity: '1 day ago'
    }]
  },
  '5': {
    name: 'Starward Homes',
    slug: 'starward',
    status: 'Active',
    users: 6,
    buyers: 234,
    joinedDate: '2023-09-08',
    projects: [{
      id: 12,
      name: 'Horizon Heights',
      status: 'Active',
      buyers: 156,
      lastActivity: '3 hours ago'
    }, {
      id: 13,
      name: 'Skyline Residences',
      status: 'Active',
      buyers: 78,
      lastActivity: '1 day ago'
    }]
  },
  '6': {
    name: 'Brookfield',
    slug: 'brookfield',
    status: 'Active',
    users: 25,
    buyers: 1245,
    joinedDate: '2022-08-20',
    projects: [{
      id: 15,
      name: 'The Meadows',
      status: 'Active',
      buyers: 456,
      lastActivity: '1 hour ago'
    }, {
      id: 16,
      name: 'Riverstone',
      status: 'Active',
      buyers: 389,
      lastActivity: '2 hours ago'
    }, {
      id: 17,
      name: 'Parkview Estates',
      status: 'Active',
      buyers: 400,
      lastActivity: '30 mins ago'
    }]
  }
};
export function BuilderDetailPage() {
  const {
    builderId
  } = useParams();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isEditingSlug, setIsEditingSlug] = useState(false);
  const [editedSlug, setEditedSlug] = useState('');
  const [copiedLink, setCopiedLink] = useState(false);
  const builder = builderData[builderId || '1'];
  useEffect(() => {
    if (builder) {
      setEditedSlug(builder.slug);
    }
  }, [builder]);
  if (!builder) {
    return <div className="p-8 text-center" data-id="element-533">
        <p className="text-slate-500" data-id="element-534">Builder not found</p>
        <Button onClick={() => navigate('/admin/builders')} className="mt-4" data-id="element-535">
          Back to Builders
        </Button>
      </div>;
  }
  const filteredProjects = builder.projects.filter((project: any) => project.name.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleSaveSlug = () => {
    console.log('Saving slug:', editedSlug);
    setIsEditingSlug(false);
  };
  const handleCopyLink = () => {
    const url = `${window.location.origin}/${builder.slug}/dashboard`;
    navigator.clipboard.writeText(url);
    setCopiedLink(true);
    setTimeout(() => setCopiedLink(false), 2000);
  };
  const handleOpenPortal = () => {
    window.open(`/${builder.slug}/dashboard`, '_blank');
  };
  return <div className="space-y-6 max-w-7xl mx-auto" data-id="element-536">
      {/* Header */}
      <div className="flex items-center gap-4" data-id="element-537">
        <Button variant="ghost" size="sm" onClick={() => navigate('/admin/builders')} leftIcon={<ArrowLeft className="h-4 w-4" data-id="element-539" />} data-id="element-538">
          Back
        </Button>
        <div className="flex-1" data-id="element-540">
          <div className="flex items-center gap-3" data-id="element-541">
            <div className="h-12 w-12 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-542">
              <Building2 className="h-6 w-6 text-slate-600" data-id="element-543" />
            </div>
            <div data-id="element-544">
              <h1 className="text-2xl font-bold text-slate-900" data-id="element-545">
                {builder.name}
              </h1>
              <p className="text-slate-500" data-id="element-546">
                Builder company details and projects
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3" data-id="element-547">
          <Badge variant={builder.status === 'Active' ? 'success' : builder.status === 'Trial' ? 'warning' : 'neutral'} data-id="element-548">
            {builder.status}
          </Badge>
          <Button variant="outline" onClick={handleOpenPortal} leftIcon={<ExternalLink className="h-4 w-4" data-id="element-550" />} data-id="element-549">
            Open Portal
          </Button>
        </div>
      </div>

      {/* Portal URL Card */}
      <Card data-id="element-551">
        <CardHeader data-id="element-552">
          <div className="flex items-center gap-2" data-id="element-553">
            <LinkIcon className="h-5 w-5 text-slate-600" data-id="element-554" />
            <CardTitle data-id="element-555">Portal URL</CardTitle>
          </div>
        </CardHeader>
        <CardContent data-id="element-556">
          <div className="flex items-center gap-4" data-id="element-557">
            {isEditingSlug ? <div className="flex items-center gap-2 flex-1" data-id="element-558">
                <span className="text-slate-500 font-mono" data-id="element-559">
                  {window.location.origin}/
                </span>
                <input type="text" value={editedSlug} onChange={e => setEditedSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))} className="px-3 py-2 border border-slate-300 rounded-md font-mono focus:ring-primary-500 focus:border-primary-500" autoFocus data-id="element-560" />
                <span className="text-slate-500 font-mono" data-id="element-561">/dashboard</span>
              </div> : <div className="flex items-center gap-2 flex-1" data-id="element-562">
                <code className="px-4 py-2 bg-slate-100 rounded-lg text-lg font-mono text-slate-800" data-id="element-563">
                  {window.location.origin}/{builder.slug}/dashboard
                </code>
              </div>}

            <div className="flex items-center gap-2" data-id="element-564">
              {isEditingSlug ? <>
                  <Button variant="ghost" size="sm" onClick={() => {
                setIsEditingSlug(false);
                setEditedSlug(builder.slug);
              }} data-id="element-565">
                    Cancel
                  </Button>
                  <Button size="sm" onClick={handleSaveSlug} leftIcon={<Save className="h-4 w-4" data-id="element-567" />} data-id="element-566">
                    Save
                  </Button>
                </> : <>
                  <Button variant="outline" size="sm" onClick={() => setIsEditingSlug(true)} leftIcon={<Edit2 className="h-4 w-4" data-id="element-569" />} data-id="element-568">
                    Edit Slug
                  </Button>
                  <Button variant="outline" size="sm" onClick={handleCopyLink} leftIcon={copiedLink ? <Check className="h-4 w-4 text-green-500" data-id="element-571" /> : <Copy className="h-4 w-4" data-id="element-572" />} data-id="element-570">
                    {copiedLink ? 'Copied!' : 'Copy Link'}
                  </Button>
                </>}
            </div>
          </div>
          <p className="text-sm text-slate-500 mt-3" data-id="element-573">
            Share this URL with {builder.name} to give them access to their
            builder portal.
          </p>
        </CardContent>
      </Card>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-574">
        <Card data-id="element-575">
          <CardContent className="p-6" data-id="element-576">
            <div className="flex items-center gap-3" data-id="element-577">
              <FolderOpen className="h-5 w-5 text-slate-400" data-id="element-578" />
              <div data-id="element-579">
                <p className="text-sm text-slate-500" data-id="element-580">Projects</p>
                <p className="text-2xl font-bold text-slate-900" data-id="element-581">
                  {builder.projects.length}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-582">
          <CardContent className="p-6" data-id="element-583">
            <div className="flex items-center gap-3" data-id="element-584">
              <Users className="h-5 w-5 text-slate-400" data-id="element-585" />
              <div data-id="element-586">
                <p className="text-sm text-slate-500" data-id="element-587">Users</p>
                <p className="text-2xl font-bold text-slate-900" data-id="element-588">
                  {builder.users}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-589">
          <CardContent className="p-6" data-id="element-590">
            <div className="flex items-center gap-3" data-id="element-591">
              <Users className="h-5 w-5 text-slate-400" data-id="element-592" />
              <div data-id="element-593">
                <p className="text-sm text-slate-500" data-id="element-594">Total Buyers</p>
                <p className="text-2xl font-bold text-slate-900" data-id="element-595">
                  {builder.buyers}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-596">
          <CardContent className="p-6" data-id="element-597">
            <div data-id="element-598">
              <p className="text-sm text-slate-500" data-id="element-599">Joined</p>
              <p className="text-lg font-semibold text-slate-900" data-id="element-600">
                {new Date(builder.joinedDate).toLocaleDateString()}
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Projects Table */}
      <Card noPadding data-id="element-601">
        <CardHeader className="border-b border-slate-200 bg-slate-50" data-id="element-602">
          <div className="flex items-center justify-between" data-id="element-603">
            <CardTitle data-id="element-604">Projects</CardTitle>
            <Button size="sm" data-id="element-605">Add Project</Button>
          </div>
        </CardHeader>

        <div className="p-4 border-b border-slate-200 bg-slate-50" data-id="element-606">
          <SearchInput className="max-w-sm bg-white" placeholder="Search projects..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-607" />
        </div>

        <div className="overflow-x-auto" data-id="element-608">
          <table className="w-full text-left text-sm" data-id="element-609">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-610">
              <tr data-id="element-611">
                <th className="px-6 py-4" data-id="element-612">Project Name</th>
                <th className="px-6 py-4" data-id="element-613">Status</th>
                <th className="px-6 py-4" data-id="element-614">Buyers</th>
                <th className="px-6 py-4" data-id="element-615">Last Activity</th>
                <th className="px-6 py-4 text-right" data-id="element-616">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-617">
              {filteredProjects.length === 0 ? <tr data-id="element-618">
                  <td colSpan={5} className="px-6 py-12 text-center text-slate-500" data-id="element-619">
                    No projects found matching "{searchQuery}"
                  </td>
                </tr> : filteredProjects.map((project: any) => <tr key={project.id} className="hover:bg-slate-50 transition-colors" data-id="element-620">
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-621">
                      {project.name}
                    </td>
                    <td className="px-6 py-4" data-id="element-622">
                      <Badge variant={project.status === 'Active' ? 'success' : 'neutral'} data-id="element-623">
                        {project.status}
                      </Badge>
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-624">
                      <div className="flex items-center gap-1" data-id="element-625">
                        <Users className="h-4 w-4 text-slate-400" data-id="element-626" />
                        {project.buyers}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-627">
                      {project.lastActivity}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-628">
                      <div className="flex items-center justify-end gap-2" data-id="element-629">
                        <Button variant="ghost" size="sm" onClick={() => navigate(`/admin/projects/${project.id}`)} data-id="element-630">
                          View Details
                        </Button>
                        <Button variant="ghost" size="sm" data-id="element-631">
                          <MoreHorizontal className="h-4 w-4" data-id="element-632" />
                        </Button>
                      </div>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}